var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component, createElement } from 'react';
import { get, assign } from 'lodash';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Popconfirm as AntPopconfirm } from 'antd';
import { services } from '@comall-backend-builder/core';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Button } from '../button';
var ITEM_CLASS_NAME = 'table-action-column-item';
var DEFAULT_MODIFY_PROPS = {
  type: 'primary',
  icon: 'edit',
  tooltip: 'Modify'
};
var DEFAULT_MODIFY_CONFIRM_PROPS = {
  type: 'primary',
  icon: 'check',
  tooltip: 'Save'
};
var DEFAULT_MODIFY_CANCEL_PROPS = {
  type: 'primary',
  icon: 'close',
  tooltip: 'Cancel'
};
var DEFAULT_DELETE_CONFIRM_PROPS = {
  title: 'Are you sure ?',
  okText: 'Yes',
  cancelText: 'No'
};
var DEFAULT_DELETE_BUTTON_PROPS = {
  type: 'primary',
  icon: 'delete',
  tooltip: 'Delete'
};
var DEFAULT_LINK_BUTTON_PROPS = {
  type: 'primary',
  icon: 'link',
  tooltip: 'Link'
};

var TableActionColumn = function (_super) {
  __extends(TableActionColumn, _super);

  function TableActionColumn() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onDeleteItem = function () {
      var _a = _this.props,
          row = _a.row,
          onDeleteItem = _a.onDeleteItem;
      onDeleteItem && onDeleteItem(row.id, row);
    };

    _this.onModifyStart = function () {
      var _a = _this.props,
          row = _a.row,
          onModifyStart = _a.onModifyStart;
      onModifyStart && onModifyStart(row);
    };

    _this.onModifyConfirm = function () {
      var _a = _this.props,
          row = _a.row,
          onModifyConfirm = _a.onModifyConfirm;
      onModifyConfirm && onModifyConfirm(row);
    };

    _this.onModifyCancel = function () {
      var _a = _this.props,
          row = _a.row,
          onModifyCancel = _a.onModifyCancel;
      onModifyCancel && onModifyCancel(row);
    };

    return _this;
  }

  TableActionColumn.prototype.render = function () {
    return React.createElement("div", null, this.generateColumnItems());
  };

  TableActionColumn.prototype.generateColumnItems = function () {
    var _this = this;

    var _a = this.props,
        row = _a.row,
        items = _a.items,
        entity = _a.entity,
        propParams = _a.params;
    return items ? items.map(function (item, index) {
      var type = item.type,
          text = item.text,
          config = item.config,
          itemParams = item.params,
          statusKey = item.statusKey,
          privilege = item.privilege;
      var params = assign({}, propParams, itemParams);
      var context = {
        row: row,
        params: params
      };
      var disabled = !(statusKey ? get(context, statusKey, true) : true);
      var props, confirmProps, actionComponent;

      if (privilege) {
        var path = privilege.path,
            level = privilege.level;

        if (!services.privilege.check(path, level)) {
          return undefined;
        }
      }

      switch (type) {
        case 'modify':
          props = __assign(__assign(__assign({}, DEFAULT_MODIFY_PROPS), config), {
            text: text,
            disabled: disabled,
            key: index,
            onClick: _this.onModifyStart
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);

          if (row._modify) {
            return undefined;
          } else {
            return React.createElement(Button, __assign({}, props));
          }

        case 'modifyConfirm':
          props = __assign(__assign(__assign({}, DEFAULT_MODIFY_CONFIRM_PROPS), config), {
            text: text,
            disabled: disabled,
            key: index,
            onClick: _this.onModifyConfirm
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);

          if (row._modify) {
            return React.createElement(Button, __assign({}, props));
          } else {
            return undefined;
          }

        case 'modifyCancel':
          props = __assign(__assign(__assign({}, DEFAULT_MODIFY_CANCEL_PROPS), config), {
            text: text,
            disabled: disabled,
            key: index,
            onClick: _this.onModifyCancel
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);

          if (row._modify) {
            return React.createElement(Button, __assign({}, props));
          } else {
            return undefined;
          }

        case 'delete':
          confirmProps = __assign(__assign(__assign({}, DEFAULT_DELETE_CONFIRM_PROPS), config), {
            key: index,
            onConfirm: _this.onDeleteItem
          });
          props = __assign(__assign(__assign({}, DEFAULT_DELETE_BUTTON_PROPS), config), {
            text: text,
            disabled: disabled
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);

          if (row._modify) {
            return undefined;
          } else {
            return React.createElement(AntPopconfirm, __assign({}, confirmProps), React.createElement(Button, __assign({}, props)));
          }

        case 'link':
          props = __assign(__assign({}, config), {
            to: services.interpolate(item.path, context),
            disabled: disabled,
            key: index
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);
          return React.createElement(Link, __assign({}, props), text);

        case 'linkButton':
          props = __assign(__assign(__assign({}, DEFAULT_LINK_BUTTON_PROPS), config), {
            text: text,
            disabled: disabled,
            key: index,
            onClick: function onClick() {
              return services.navigation.goto(services.interpolate(item.path, context));
            }
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);
          return React.createElement(Button, __assign({}, props));

        case 'component':
          actionComponent = ComponentsManager.get(item.component);
          props = __assign(__assign({}, config), {
            params: params,
            text: text,
            row: row,
            key: index,
            entity: entity,
            disabled: disabled
          });
          props.className = classNames(props.className, ITEM_CLASS_NAME);
          return createElement(actionComponent, props);

        default:
          return null;
      }
    }) : null;
  };

  return TableActionColumn;
}(Component);

export { TableActionColumn };